import {map} from 'lodash'

const LOAD = 'server-sts/commercial/LOAD';
const LOAD_SUCCESS = 'server-sts/commercial/LOAD_SUCCESS';
const LOAD_FAIL = 'server-sts/commercial/LOAD_FAIL';

const EDIT_START = 'server-sts/commercial/EDIT_START';
const EDIT_STOP = 'server-sts/commercial/EDIT_STOP';

const SAVE = 'server-sts/commercial/SAVE';
const SAVE_SUCCESS = 'server-sts/commercial/SAVE_SUCCESS';
const SAVE_FAIL = 'server-sts/commercial/SAVE_FAIL';

const CREATE = 'server-sts/commercial/CREATE';
const CREATE_SUCCESS = 'server-sts/commercial/CREATE_SUCCESS';
const CREATE_FAIL = 'server-sts/commercial/CREATE_FAIL';


const initialState = {
  loaded          : false,
  loading         : false,
  created         : false,
  editing         : {},
  saveError       : {},
  sending         : {},
  
  updateSuccess   : false,
  updateError     : false, 
  createLoading   : false,
  createFail      : false,
  createSuccess   : false,
  
  
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        error: null
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error
      };
   
    case EDIT_START:
      return {
        ...state,
        editing: {
          ...state.editing,
          [action.id]: true
        }
      };
    case EDIT_STOP:
      return {
        ...state,
        editing: {
          ...state.editing,
          [action.id]: false
        }
      };

   

    case CREATE:
      return {
    		...state,
    		loading:true,
    		createError:false,
        createSuccess:false,
    	};

    case CREATE_SUCCESS:
    	return {
				...state,
				created:true,
				loading:false,
				createError:false,
				createSuccess:true,
			};

    case CREATE_FAIL:
    	return {
				...state,
				created:false,
				loading:false,
				createError:true,
			};

    case SAVE:
      return state;

    case SAVE_SUCCESS:
      //var data = [...state.data];
      return {
        ...state,
        //data: action.result,
        editing: {
          ...state.editing,
          [action.id]: false
        },
        saveError: {
          ...state.saveError,
          [action.id]: null
        }
      };

    case SAVE_FAIL:
      return typeof action.error === 'string' ? {
        ...state,
        saveError: {
          ...state.saveError,
          [action.id]: action.error
        }
      } : state;
    default:
      return state;
  }
}

export function create(values) {
  return {
    types: [CREATE, CREATE_SUCCESS, CREATE_FAIL],
    promise: (client) => client.post('/commercial/create', {
      data: {
      	values
      }
    })
  };
}

export function load() {
  return {
    promise: (client) => client.post('/commercial/load'),
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL]
  };
}

export function save(values, params) {
  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    id: values.id,
    promise: (client) => client.post('/commercial/update', {
      data: {values, params}
    })
  };
}

export function deleteCom(username) {
  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    promise: (client) => client.post('/commercial/delete', {
      data: {username}
    })
  };
}


export function editStart(id) {
  return { type: EDIT_START, id };
}

export function editStop(id) {
  return { type: EDIT_STOP, id };
}

export function consultClient(client) {
  return { type: CONSULT, client };
}
